<template>
    <div class="row">
      <user-avatar-component :avatarURL="itemUserAvatarUrl" :userLevel="userLevel" id="userAvatar"/>

      <div class="col">
        <a id="usernameLabel" @click="showProfile">{{username}}</a>
        <p id="creationDateLabel">{{creationString}}</p>
      </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { randomFileServer } from '@/services/Api'
import { emitter } from '@/main'
import { EmittEvent } from '@/dto/enums/EmittEvent'
import UserAvatarComponent from '@/views/components/UserAvatarComponent.vue'
import { logProfileClick } from '@/services/EventLogger'

export default defineComponent({
  components: {
    UserAvatarComponent
  },

  props: {
    username: {
      type: String,
      default: 'anonym'
    },
    itemUserAvatarUrl: {
      type: String
    },
    userLevel: {
      type: Number
    },
    createdAt: {
      type: Date,
      required: true
    }
  },

  setup() {
    return { }
  },

  computed: {
    avatarURL() {
      const fs = randomFileServer()
      if (fs && this.itemUserAvatarUrl) {
        const fullPath = fs.concat(this.itemUserAvatarUrl)
        return fullPath
      } else {
        // ... RETURN DEFAULT IMAGE
      }
      return null
    },
    creationString(): String {
      return this.createdAt?.toLocaleString()
    }
  },

  methods: {
    showProfile() {
      logProfileClick()
      emitter.emit(EmittEvent.downloadAppAlert)
    }
  }
})
</script>

<style lang="sass" scoped>
#userAvatar
  width: 48px
  padding: 0

#usernameLabel
  margin-bottom: 0
  font-weight: 700
  font-size: 1rem
  cursor: pointer

#creationDateLabel
  margin-bottom: 0
  font-weight: 500
  font-size: 0.9rem
  color: $color_on_background_medium
</style>
